import { Amplify } from 'aws-amplify';
import { config, isUnconfigured } from './env.js';

/**
 * Cognito is configured once, at module load. Sign-up is disabled in the user
 * pool itself, so the SPA never renders a registration form.
 */
if (!isUnconfigured) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.VITE_USER_POOL_ID,
        userPoolClientId: config.VITE_USER_POOL_CLIENT_ID,
        signUpVerificationMethod: 'code',
        loginWith: { email: true },
      },
    },
  });
}
